/*
 * 维护单组件引擎入口：每个 Formily form 对应一个引擎实例（头部/检查清单/维护收尾共享状态）
 * platform 为平台能力（PC / 企微手机端各自实现）：
 *   scrollEl() / isMobileUA() / locate(ctx) / scan() / uploadHeaders()
 */
import { toJS } from "@formily/reactive";
import installCore from "./core";
import installUi from "./ui";
import installBiz from "./biz";
import installOffline from "./offline";
import installSync from "./sync";
import installPoints from "./points";
import installHeader from "./header";
import installMiddle from "./middle";
import installMiddleDg from "./middle_dg";
import installParallelDg from "./parallel_dg";
import installFooter from "./footer";

const engines = new WeakMap();

function formHost(form, MW, platform) {
  let writing = 0;
  let timer = null;
  return Object.assign({}, platform, {
    read() {
      return JSON.parse(JSON.stringify(toJS(form.values) || {}));
    },
    write(key, value) {
      writing++;
      try {
        form.setValuesIn(key, value);
      } finally {
        writing--;
      }
    },
    /** 平台改写表单值（如待办数据刷新）时，把差异拉回组件 */
    subscribe(fn) {
      const id = form.subscribe(({ type }) => {
        if (type !== "onFormValuesChange" || writing) return;
        clearTimeout(timer);
        timer = setTimeout(() => fn(this.read()), 30);
      });
      return () => {
        clearTimeout(timer);
        form.unsubscribe(id);
      };
    },
    /** 表单或组件字段为禁用 / 只读时，组件整体只读 */
    readonly() {
      if (form.pattern && form.pattern !== "editable") return true;
      return MW.fields.some((f) => f.pattern && f.pattern !== "editable");
    },
  });
}

export function getEngine(form, platform) {
  let MW = engines.get(form);
  if (MW) return MW;
  MW = { fields: [] };
  const host = formHost(form, MW, platform || {});
  MW.host = host;
  installCore(MW, host);
  installUi(MW, host);
  installBiz(MW, host);
  installOffline(MW, host);
  installSync(MW, host);
  installHeader(MW, host);
  installMiddle(MW, host);
  installPoints(MW, host);
  installMiddleDg(MW, host);
  installParallelDg(MW, host);
  installFooter(MW, host);
  engines.set(form, MW);
  return MW;
}

/** 组件卸载时释放；三个组件都卸载后销毁引擎 */
export function releaseEngine(form, field) {
  const MW = engines.get(form);
  if (!MW) return;
  const i = MW.fields.indexOf(field);
  if (i > -1) MW.fields.splice(i, 1);
  if (!MW.fields.length) {
    MW.destroy();
    engines.delete(form);
  }
}
